import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const Loader = ({ label = "Loading..." }) => (
  <div className="flex items-center justify-center py-20 text-muted-foreground" data-testid="loader">
    <Loader2 className="w-6 h-6 animate-spin mr-2 text-teal" /> {label}
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action, testId = "empty-state" }) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid={testId}>
    {Icon && (
      <div className="w-16 h-16 rounded-2xl bg-teal/10 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-teal" />
      </div>
    )}
    <h3 className="font-heading text-lg font-semibold text-foreground">{title}</h3>
    {description && <p className="text-sm text-muted-foreground mt-1 max-w-md">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

const STATUS = {
  not_submitted: { label: "Not Submitted", cls: "bg-slate-100 text-slate-600" },
  under_review: { label: "Under Review", cls: "bg-amber-100 text-amber-700" },
  approved: { label: "Approved", cls: "bg-green-100 text-green-700" },
  needs_revision: { label: "Needs Revision", cls: "bg-red-100 text-red-700" },
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-700" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
  open: { label: "Open", cls: "bg-teal/10 text-teal" },
  resolved: { label: "Resolved", cls: "bg-green-100 text-green-700" },
  graded: { label: "Graded", cls: "bg-teal/10 text-teal" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  return (
    <span className={cn("inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold", s.cls)} data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
};
